export default __webpack_public_path__ + "static/media/=AFISHA FR.tif  copy(2).ccba7f76.jpg";